<template>
  <div style="width:100%;">
    <div style="position: fixed;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="show" v-if="inputForm.isDoTask">
          办理
        </van-button>
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="close">返回</van-button>
      </div>

      <div class="doTask" v-if="isshow">
        <div>
          <van-field name="radio" label="审批意见">
            <template #input>
              <van-radio-group v-model="auditForm.status" direction="horizontal">
                <van-radio name="同意">同意</van-radio>
                <van-radio name="不同意">不同意</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </div>
        <div>
          <van-cell-group>
            <van-field v-model="auditForm.message" rows="2" autosize label="审批说明" type="textarea"
                       placeholder="请输入审批说明"/>
          </van-cell-group>
        </div>
        <div style="text-align:center">
          <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="submitTask()">提交</van-button>
        </div>
      </div>
    </div>

    <van-collapse v-model="activeNames" style="margin-top: 60px;">
      <van-collapse-item title="合同信息" name="1">
        <van-field v-model="inputForm.contractCode" label="合同编号" label-width="130px" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.name" label="商位名称" label-width="130px" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.code" label="商位编号" label-width="130px" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.propertyArea" label="商位面积（㎡）" label-width="130px" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.sname" label="商户姓名" label-width="130px" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.categoryName" label="经营类别" label-width="130px" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.brandName" label="经营品牌" label-width="130px" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.mobile" label="联系电话" label-width="130px" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.address" label="联系地址" label-width="130px" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.dateRange" label="合同期限" label-width="130px" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.signingDate" label="合同签订日期" label-width="130px" readonly autosize rows='1'
                   type="textarea"/>
      </van-collapse-item>
      <van-collapse-item title="撤场信息" name="2">
        <van-field v-model="inputForm.typeName" label="撤场类型" label-width="130px" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.inDate" label="进场日期" label-width="130px" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.leaveDate" label="撤场申请日期" label-width="130px" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.predictDate" label="预计撤场日期" label-width="130px" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.realityDate" label="实际撤场日期" label-width="130px" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.handerName" label="经办人" label-width="130px" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.leasedeadline" label="计费截止日期" v-if="inputForm.type==='2'" label-width="130px" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.breach" label="违约情况" label-width="130px" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.remarks" label="备注" label-width="130px" readonly autosize rows='1'
                   type="textarea"/>
        <van-field label="抄表情况" label-width="100px" v-if="inputForm.meters&&inputForm.meters.length!=0" readonly>
          <template #button>
            <van-button plain type="default" @click="view">查看抄表情况</van-button>
          </template>
        </van-field>
        <van-field label="应收明细" label-width="100px" readonly>
          <template #button>
            <van-button plain type="default" @click="receivablesView">查看应收明细</van-button>
          </template>
        </van-field>
        <van-field label="保证金明细" label-width="100px" v-if="depositsList&&depositsList.length!=0" readonly>
          <template #button>
            <van-button plain type="default" @click="depositsView">查看保证金明细</van-button>
          </template>
        </van-field>
        <div style="padding-left: 16px;" v-show="inputForm.attachList.length > 0">
          <p>撤场资料</p>
          <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.attachList" :key="index" @click="$viewAttach(file)">{{file.name}}</p>
        </div>
      </van-collapse-item>
    </van-collapse>
    <process-record :procInsId="procInsId"></process-record>
  </div>
</template>

<script>
import TaskService from '@/api/flowable/TaskService.js'
import ProcessService from '@/api/flowable/ProcessService'
import MarchOutService from "@/api/contract/MarchOutService";
import processRecord from "../../../components/processRecord/processRecord";

export default {
  data() {
    return {
      activeNames: ['1', '2'],
      isshow: false,
      radio: '',
      inputForm: {
        id: '',
        projectId: '',
        area: '',
        houseType: '',
        floor: '',
        houseStatus: '',
        type: '',
        houseUseStatus: '',
        code: '',
        propertyArea: '',
        isEnabled: '1',
        remark: '',
        areaName: '',
        isDoTask: false,
        isLastTask: false
      },
      auditForm: {
        message: '',
        type: '_flow_agree',
        status: '同意',
        userIds: null,
        assignee: null
      },
      receivablesList:[],
      depositsList:[],
      taskId: '',
      taskDefKey: '',
      procInsId: '',
      procDefId: '',
      businessId: '',
      type: ''
    }
  },
  components: {
    processRecord
  },
  mounted() {
  },
  created() {
    let query = this.$route.query;
    this.businessId = query.id
    this.taskId = query.taskId
    this.taskDefKey = query.taskDefKey
    this.procInsId = query.procInsId
    this.procDefId = query.procDefId
    this.type = query.type || ''
    this.init(this.businessId)
    // this.init('1775348599780687873')
    if(!window.matchMedia("(orientation:portrait)").matches){
      dd.device.screen.resetView({
        onSuccess : function(result) {
        },
        onFail : function(err) {}
      });
    }
  },
  methods: {
    show() {
      this.isshow = !this.isshow
    },
    init(id) {
      new MarchOutService().queryById(id).then(({data}) => {
        this.inputForm = data
        this.$set(this.inputForm, `typeName`,this.inputForm.type==1?'合同到期':this.inputForm.type==2?'提前撤场':'恶意逃铺' );
        this.$set(this.inputForm, `inDate`,this.inputForm.inDate.slice(0, 10));
        this.$set(this.inputForm, `dateRange`,`${this.inputForm.startDate}至${this.inputForm.endDate}` );
        const contractId = this.inputForm.startContractId ? this.inputForm.startContractId : this.inputForm.serviceId;
        new MarchOutService().feeDetailsByContractId(this.inputForm.projectId, 3, contractId).then(({ data }) => {
          this.$set(this.inputForm, 'meters', data);
        });
        this.inputForm.leasedeadline=this.inputForm.type==2?this.inputForm.leasedeadline:null
        new MarchOutService().getReceivables(this.inputForm.serviceId,this.inputForm.leasedeadline).then(({data}) => {
          this.receivablesList = data.others
          this.depositsList = data.deposits
        })
      }).catch(e => {
        console.log(e)
      })
    },
    view() {
      this.$router.push({
        path: 'shye_march_out_detail',
        query: {
          data: this.inputForm
        }
      })
    },
    receivablesView() {
      this.$router.push({
        path: 'shye_march_out_fee_detail',
        query: {
          data: this.receivablesList
        }
      })
    },
    depositsView() {
      this.$router.push({
        path: 'shye_march_out_fee_detail',
        query: {
          data: this.depositsList
        }
      })
    },
    close() {
      if (this.type !== '') {
        this.$router.back()
      } else {
        //Android、iOS支持PC不支持
        dd.biz.navigation.close({
          onSuccess: function (result) {
          },
          onFail: function (err) {
          }
        })
        //Android、iOS不支持，PC支持
        dd.biz.navigation.quit({
          message: "quit message",
          onSuccess: function (result) {
          },
          onFail: function () {
          }
        })
      }
    },
    submitTask() {
      if (this.auditForm.status == '同意') {
        this.agree()
      } else {
        this.reject()
      }
    },
    agree() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        let vars = {}
        vars = {...vars, ..._this.inputForm}
        _this.auditForm.message = _this.inputForm.remarks

        _this.auditForm.type = _this.inputForm.isLastTask ? '_flow_approval' : '_flow_agree'

        new TaskService().audit({
          taskId: _this.taskId,
          taskDefKey: _this.taskDefKey,
          procInsId: _this.procInsId,
          procDefId: _this.procDefId,
          businessTable: 'shye_finance_receivable_adjust',
          businessId: this.businessId,
          vars: vars,
          comment: _this.auditForm,
          assignee: _this.auditForm.assignee
        }).then(({data}) => {
          // if(data.code === 200) {
            _this.$toast.clear();
            _this.$toast.success('提交成功');
            //更新数据库状态
			let form = {
				id: _this.inputForm.id,
				flowType: _this.inputForm.isLastTask ? 4 : 2,
				formKey: _this.formKey,
				type: _this.inputForm.type
			}
            new MarchOutService().startFlow(form);

            setTimeout(function () {
              _this.close()
            }, 800)
          // } else {
          //   _this.$toast.clear();
          //   _this.$toast.fail(data.msg);
          //   setTimeout(function () {
          //     _this.close()
          //   }, 800)
          // }
        })
      }).catch(() => {
      })
    },
    reject() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        new ProcessService().stop(_this.procInsId, _this.auditForm.message).then(({data}) => {
          // if(data.code === 200) {
            _this.$toast.clear();
            _this.$toast.success('提交成功');
            //更新数据库状态
			let form = {
				id: _this.inputForm.id,
				flowType: 3,
				formKey: _this.formKey
			}
            new MarchOutService().startFlow(form);

            setTimeout(function () {
              _this.close()
            }, 800)
          // } else {
          //   _this.$toast.clear();
          //   _this.$toast.fail(data.msg);
          //   setTimeout(function () {
          //     _this.close()
          //   }, 800)
          // }
        })
      }).catch(() => {
      })
    }
  }
}
</script>
